import React, { useEffect } from 'react';
import { Box, CSSReset, ChakraProvider, Flex, Text, VStack } from '@chakra-ui/react';
import { chakraTheme } from 'theme/chakra/chakraTheme';
import { round } from 'lodash';
import { CommercialParkItem } from './components/CommercialParkItem';
import { useRematchDispatch, useRematchSelector } from 'models/rematchStore';
import { useGroups } from './useGroups';
import { GroupTabs } from 'components/PortfolioShared/GroupTabs';
import { updateWebSocketForParks } from 'common/webSocketManager';
import { Logger } from 'common/logger';

export function OperationsCommercial() {
    const parkConfigs = useRematchSelector((state) => state.parksData.parkConfigs);
    const plantData = useRematchSelector((state) => state.parksData.plantData);
    const token = useRematchSelector((state) => state.account.token);

    const { groups, tabIndex, addGroup, onRemoveGroup, saveGroup, setTabIndex, checkedItems } = useGroups();
    const dispatch = useRematchDispatch();

    useEffect(() => {
        Logger.debug(`Make connections to:`, checkedItems);
        updateWebSocketForParks(checkedItems, token);
    }, [checkedItems, token]);

    const hasAppConfig = Object.keys(parkConfigs).length > 0;

    useEffect(() => {
        if (dispatch && token && !hasAppConfig) {
            dispatch({ type: 'parksData/loadAppConfig', payload: { token } });
        }
    }, [dispatch, hasAppConfig, token]);

    const firstParkName = checkedItems?.length > 0 ? checkedItems[0] : null;
    const parkPlantData = plantData[firstParkName?.toLowerCase()] || {};
    const powerPrice = parkPlantData?.power_sales_price?.value;

    return (
        <ChakraProvider theme={chakraTheme}>
            <CSSReset />
            <Box>
                <Flex bg="grayDark" pl={4} alignItems="center" pr={4}>
                    <GroupTabs
                        groups={groups}
                        addGroup={addGroup}
                        onRemoveGroup={onRemoveGroup}
                        saveGroup={saveGroup}
                        tabIndex={tabIndex}
                        setTabIndex={setTabIndex}
                    />
                    <Box flex={1} />
                    <Flex>
                        <Text casing="uppercase" fontSize="sm" fontWeight="bold" mr={1}>
                            Power Price:
                        </Text>
                        <Text color="gray2" fontSize="sm" mr={1}>
                            £
                        </Text>
                        <Text fontSize="sm" fontWeight="bold">
                            {powerPrice ? round(powerPrice, 2) : 'N/A'}
                        </Text>
                    </Flex>
                </Flex>
                <VStack spacing={4} align="stretch" margin={4}>
                    {checkedItems?.map((parkName) => (
                        <CommercialParkItem key={parkName} parkName={parkName.toLowerCase()} />
                    ))}
                </VStack>
            </Box>
        </ChakraProvider>
    );
}
